import api from './client'
import type { DeploymentTask, PaginatedResponse } from '../api'

export const deploymentApi = {
  list: async (params: Record<string, string> = {}): Promise<PaginatedResponse<DeploymentTask>> => {
    const response = await api.get<PaginatedResponse<DeploymentTask>>('/deployment-tasks', { params })
    return response.data
  },

  retry: async (taskId: string): Promise<{ message: string; task_id: string }> => {
    const response = await api.post(`/deployment-tasks/${taskId}/retry`)
    return response.data
  },

  completePaxBuild: async (
    taskId: string,
    payload: { serial_number?: string | null; terminal_id?: string | null; notes?: string | null },
  ): Promise<{ message: string; equipment_asset_id: string }> => {
    const response = await api.post(`/deployment-tasks/${taskId}/complete`, payload)
    return response.data
  },

  cancelTask: async (
    merchantId: string,
    taskId: string,
  ): Promise<{ id: string; status: string; adapter_type: string }> => {
    const response = await api.post(`/merchants/${merchantId}/services/${taskId}/cancel`)
    return response.data
  },
}
